import { useAtom } from 'jotai';

import {
  InitialTriviaData,
  triviaAtom,
  initialTriviaState,
} from '@/store/trivia';

const useTrivia = () => {
  const [triviaData, setTriviaData] = useAtom(triviaAtom);

  const handleSetTrivia = (data: InitialTriviaData) => {
    setTriviaData(data);
  };

  const updateTrivia = (updates: Partial<InitialTriviaData>) => {
    setTriviaData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const handleResetTrivia = () => {
    setTriviaData(initialTriviaState);
  };

  return {
    triviaData,
    handleSetTrivia,
    handleResetTrivia,
    updateTrivia,
  };
};

export default useTrivia;
